import { DurationLike, UnixDuration } from '../time/duration/UnixDuration.js'

export function sleep(duration: DurationLike): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, Number(UnixDuration.fromDurationLike(duration).toMilliseconds())))
}
